import { useProjectMutations } from '@/modules/projects/hooks'
import type { CaseTypeConfig } from '@/modules/projects/stores/caseConfig'
import { planCaseTypeChange } from './caseDetailCells'

// Each save writes one answer. Saves are queued and built from the latest project, so two
// quick edits never undo each other.
export const useCaseDetailSaves = () => {
  const { updateProject, queueCaseSave } = useProjectMutations()

  const saveDetail = (key: string, value: string) =>
    queueCaseSave((project) =>
      updateProject({ case_details: { ...project.caseDetails, [key]: value } }),
    )

  const saveAccountsScope = (accountsType: string) =>
    queueCaseSave(() => updateProject({ case_accounts_type: accountsType }))

  const saveCaseType = (caseType: string, config: CaseTypeConfig) =>
    queueCaseSave(async (project) => {
      const change = planCaseTypeChange(project, config, caseType)
      await updateProject({
        case_type: caseType,
        case_details: change.keptDetails,
      })
      // Lukita clears every answer when the type changes and the answers did not. Write them back.
      const wasCleared =
        change.droppedLabels.length === 0 &&
        Object.keys(change.keptDetails).length > 0
      if (!wasCleared) return
      const restore = () => updateProject({ case_details: change.keptDetails })
      await restore().catch(restore)
    })

  return { saveDetail, saveAccountsScope, saveCaseType }
}
